import { render } from "./ListaUsuarios.vue?vue&type=template&id=7084052c"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__